module.exports = __webpack_public_path__ + "static/media/badge_pinde.f93c1ed9.svg";